document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const discountTitle = event.target.closest('.amp-cart__discount-box-title');
    const parent = discountTitle?.closest(".amp-cart__discount-box");
    if (parent) {
      parent.classList.toggle('active');
    }
  });
});